import styled from 'styled-components';

const Section = styled.div`
  padding: ${({ theme }) => theme.spacing(6, 0)};
  &:not(:last-of-type) {
    border-bottom: ${({ theme }) => theme.colors.platinum} 1px solid;
  }
`;

export default Section;
